import { ActivityIndicator, View } from 'react-native';
import { useAuth } from '~/hooks/useAuth';
import { AuthenticatedShell } from '~/navigation/AuthenticatedShell';
import { LoginScreen } from '~/screens/Login/LoginScreen';
import { NoAccessScreen } from '~/screens/NoAccess/NoAccessScreen';
import { useTheme } from '~/theme/ThemeProvider';

/**
 * AuthGate: spinner → Login → authenticated shell.
 *
 * The spinner sits on `bg` rather than `surface` deliberately — it is the pre-app state,
 * behind everything, and matching the native splash background is what stops a visible
 * flash between the splash and the first screen.
 */
export function AuthGate() {
  const auth = useAuth();
  const { c } = useTheme();

  if (auth.status === 'loading') {
    return (
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: c.bg,
        }}
      >
        <ActivityIndicator size="large" color={c.primary} />
      </View>
    );
  }
  if (auth.status === 'unauthenticated') {
    return <LoginScreen />;
  }
  /*
    Before the shell, not inside it. Someone without the operator role has a valid session
    and no route into this app, so the answer is a different screen rather than an
    authenticated shell with every action refused behind it (frame 00c).
  */
  if (auth.status === 'no_access') {
    return <NoAccessScreen />;
  }
  return <AuthenticatedShell />;
}
